$(function(){
  $('.skill_tab li').click(function(){
    var index=$(this).index()
    $('.skill_tab li').removeClass("skill_focus").eq(index).addClass("skill_focus");
    $(".skill_gif img").attr("src","img/skill_gif"+index+".gif?v=2")
    $(".skill_png img").attr("src","img/skill_"+index+".png?v=2")
  })
});